import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPilone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"pilone, maintenance"} maskId="square-filled-radius-0-stroke-1-IconPilone"><path d="M6.89844 10L9.12065 2H14.8807L17.103 10H6.89844Z" fill="currentColor"/><path d="M6.61849 11L5.78516 14H18.2119L17.3786 11H6.61849Z" fill="currentColor"/><path d="M18.4911 15H5.50884L4.11996 20H2V21H22V20H19.88L18.4911 15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPilone;
